import { get } from "lodash";
import React from "react";
import {
	ChipField,
	EditButton,
	List as RaList,
	TextField,
} from "react-admin";
import CopyLinkButton from "../channels/CopyLinkButton";
import { ChannelsBulkActions } from "../channels/CopyLinksButton";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import useNetwork from "../useNetwork";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import StatusField from "./fields/StatusField";
import Filters from "./Filters";

const Datagrid = ({ network, ...props }) => {
	const hasBookmakerFilter = !!get(props, "filterValues.bookmaker_id");
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField
						source="name"
						variant="h6"
						style={{ fontWeight: "bold" }}
					/>
					<EditButton />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<TextField source="remote_id" />
					<TextField source="remote_name" />
					<TextField source="user.name" />
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					<StatusField source="status" />
					<CopyLinkButton network={network} source="hash" />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasBookmakerFilter && (
				<ChipField source="bookmaker.name" sortBy="Bookmakers.name" />
			)}
			<TextField source="name" />
			<TextField source="remote_id" />
			<TextField source="remote_name" />
			<TextField source="user.name" />
			<StatusField source="status" />
			<EditButton />
			<CopyLinkButton
				network={network}
				source="hash"
				label=""
				sortable={false}
			/>
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	const { network } = useNetwork();
	return (
		<RaList
			classes={classes}
			actions={<Actions />}
			filters={<Filters />}
			perPage={perPage()}
			sort={{ field: "id", order: "DESC" }}
			bulkActionButtons={<ChannelsBulkActions network={network} />}
			{...props}
		>
			<Datagrid {...props} network={network} />
		</RaList>
	);
};
export default List;
